import React from "react";
import classNames from "classnames";
import { useDrag } from "react-dnd";

import { Props } from "./types";
import styles from "./styles.scss";

function Draggable(props: Props) {
  const signaledDrag = React.useRef(false);
  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: props.type,
      item: { type: props.type, payload: props.data },
      canDrag: !props.isDisabled,
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [{ type: props.type, payload: props.data }],
  );

  React.useEffect(() => {
    if (isDragging && props.startDrag) {
      props.startDrag();
      signaledDrag.current = true;
    }

    if (!isDragging && signaledDrag.current) {
      props.stopDrag && props.stopDrag();
      signaledDrag.current = false;
    }

    return () => {
      props.stopDrag && props.stopDrag();
      signaledDrag.current = false;
    };
  }, [isDragging]);

  return (
    <div
      ref={dragRef as unknown as React.Ref<HTMLDivElement>}
      className={classNames(props.className, {
        [styles.grabbingCursor]: isDragging,
        [props.draggedClassName || ""]: isDragging && !!props.draggedClassName,
      })}
    >
      {props.children}
    </div>
  );
}

export { Draggable };
